// extracted by mini-css-extract-plugin
module.exports = {"off-grid-fix-tab":"FixTab_off-grid-fix-tab__O2Hq5"};